<template>
  <div class="d-flex">
    <b-button
      style="height: 40px; width: 119.664px;"
      id="tank-orien-horz"
      block
      variant="no-outline"
      @click.stop="goToAppleStore"
      class="py-0 mx-0 d-flex align-items-center justify-content-center mr-2 p-0"
      data-test-hook="tank-enrollment-step-3-tank-orientation-horizontal-button"
    >
      <b-img
        :src="require('@/assets/images/DownloadOnAppStore-Badge-Web.svg')"
        data-test-hook="tank-enrollment-step-3-tank-orientation-horizontal-image"
        class="mx-auto d-block mt-3"
        style="object-fit: fill;"
      />
    </b-button>
    <b-button
      style="height: 40px; width: 135px; aspect-ratio: 27/8;"
      id="tank-orien-horz"
      block
      variant="no-outline"
      @click.stop="goToGoogleStore"
      class="py-0 mx-0 d-flex align-items-center justify-content-center mr-2 p-0"
      data-test-hook="tank-enrollment-step-3-tank-orientation-horizontal-button"
    >
      <b-img
        :src="require('@/assets/images/GetItOnGooglePlay-Badge-Web.svg')"
        data-test-hook="tank-enrollment-step-3-tank-orientation-horizontal-image"
        class="mx-auto d-block"
        style="object-fit: fill;"
      />
    </b-button>
  </div>
</template>
<script>
import * as Constants from '@/constants'

export default {
  methods: {
    goToGoogleStore() {
      window.open(Constants.GoogleStoreMobileLinkURL, '_blank')
    },
    goToAppleStore() {
      window.open(Constants.AppleStoreMobileLinkURL, '_blank')
    }
  }
}
</script>
